import { ContactDetails } from '@mobi/api-types'
import { ContactDetailsBody } from '../Hooks/useEditContactDetails'

const defaultPhoneCountryCode = '61'

export function isInternationalCustomer(
  residentialAddress?: ContactDetails['ResidentialAddress']
): boolean {
  return Boolean(
    residentialAddress?.Country &&
      residentialAddress.Country.length > 0 &&
      residentialAddress.Country?.toLowerCase() !== 'australia'
  )
}

export const formatFullName = (name: ContactDetails['NameDetails']): string =>
  [name.FirstName, name.MiddleName, name.Surname].filter(n => !!n).join(' ')

export function parseLandlinePhoneNumber(
  phoneNumber: string
): ContactDetailsBody['contactDetails']['homePhone'] {
  const regex = /^\s*(\d{2})(\d{8})\s*$/
  const result = phoneNumber && regex.exec(phoneNumber.replace(/\s/g, ''))
  return result
    ? {
        countryCode: defaultPhoneCountryCode,
        areaCode: result[1],
        phoneNumber: result[2],
      }
    : {
        countryCode: '',
        areaCode: '',
        phoneNumber: '',
      }
}

export function parseMobilePhoneNumber(
  phoneNumber: string
): ContactDetailsBody['contactDetails']['mobile'] {
  const regex = /^\s*(\d{10})\s*$/
  const result = phoneNumber && regex.exec(phoneNumber.replace(/\s/g, ''))
  return result
    ? {
        countryCode: defaultPhoneCountryCode,
        phoneNumber: result[1],
      }
    : {
        countryCode: '',
        phoneNumber: '',
      }
}
